import React from 'react';
import { usePathname } from 'next/navigation';
import { useApolloClient } from '@apollo/client';
import * as S from './HeaderTitle.styles';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { ROUTES } from '@/constants/routes';
import { LogoLink } from '@/components/LogoLink/LogoLink';
import { useResponsive } from '@/hooks/useResponsive';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';
import { useBannerStore } from '@/store/useBannerStore/useBannerStore';

interface HeaderTitleProps {
  title?: string;
}

export const HeaderTitle = ({ title }: HeaderTitleProps) => {
  const { isDesktop } = useResponsive();
  const pathname = usePathname();
  const client = useApolloClient();
  const reloadBanners = useBannerStore(state => state.reloadBanners);
  const customPush = useCustomPush();

  const [isDesktopCatalogueOpen, toggleDesktopCatalogue] =
    useDesktopCatalogueStore(state => [
      state.isDesktopCatalogueOpen,
      state.toggleDesktopCatalogue,
    ]);
  const [isNavOpen, toggleNav] = useNavMenuStore(state => [
    state.isNavOpen,
    state.toggleNav,
  ]);

  const isBookmarksPage = pathname === ROUTES.bookmarks;
  const isHomePage = pathname === ROUTES.home;

  async function onLogoLinkClick(e: React.MouseEvent) {
    e.preventDefault();

    if (isDesktopCatalogueOpen) toggleDesktopCatalogue();
    if (isNavOpen) toggleNav();

    if (isHomePage) {
      reloadBanners();
      await client.resetStore();
    } else {
      await client.clearStore();
    }

    await customPush(ROUTES.home);
  }

  return title && !isDesktop ? (
    <S.HeaderTitleBox {...(isBookmarksPage && { as: 'h1' })}>
      {title}
    </S.HeaderTitleBox>
  ) : (
    <LogoLink onClick={onLogoLinkClick} />
  );
};
